import React, { useState, forwardRef, useImperativeHandle } from 'react'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
const CompetitionFormatted = forwardRef(({ defaultvar = '' }, ref) => {
  const currencies_competition_format = [
    {
      value: 'Парные соревнования',
      label: 'Парные соревнования',
    },
    {
      value: 'Парно - командные соревнования',
      label: 'Парно - командные соревнования',
    },
    {
      value: 'Командные соревнования',
      label: 'Командные соревнования',
    },
    {
      value: 'Парные соревнования (по зонам)',
      label: 'Парные соревнования (по зонам)',
    },
  ]

  const [value, setValue] = React.useState(defaultvar)
  const [error, setError] = useState('')
  const val = () => {
    return value.trim()
  }
  const validate = () => {
    if (value.trim() === '') {
      setError('Продолжительность турнира обязательно')
      return false
    }
    setError('')
    return true
  }
  useImperativeHandle(ref, () => ({
    validate,
    val,
  }))
  return (
    <TextField
      id="competition_format"
      select
      label="Формат соревнования"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      error={!!error}
      // helperText={error}
      variant="filled"
    >
      {currencies_competition_format.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  )
})

export default CompetitionFormatted
